import { TypeQuoteFields } from 'bb-contentful-types'

import { withContentful } from 'src/siteBuilder/renderer/contentful/withContentful'
import Quote from './Quote'

const ContentfulQuote = withContentful<TypeQuoteFields>(Quote, {
  quote: (props) => {
    const data = props?.fields
    return {
      text: data.text,
      image: data.image,
      ctaLink: data.ctaLink,
      level: data.level,
      author: data.author,
    }
  },
})

export default ContentfulQuote
